import * as React from 'react';

export const LinkedinIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M8.102 3.75a2.476 2.476 0 00-2.477 2.476c0 1.367 1.109 2.5 2.476 2.5 1.366 0 2.477-1.133 2.477-2.5A2.475 2.475 0 008.102 3.75zm12.087 6.563c-2.08 0-3.27 1.087-3.841 2.17h-.06v-1.88h-4.1v13.772h4.271v-6.817c0-1.796.136-3.532 2.359-3.532 2.19 0 2.223 2.048 2.223 3.646v6.703h4.272v-7.564c0-3.701-.796-6.498-5.124-6.498zm-14.223.29v13.772h4.275V10.604H5.966z"
        fill="#7B88A8"
      />
    </svg>
  );
};

export const GithubIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.75C8.785 3.75 3.75 8.785 3.75 15c0 4.97 3.223 9.188 7.694 10.675.564.103.77-.242.77-.542 0-.267-.012-.974-.016-1.912-3.13.678-3.79-1.508-3.79-1.508-.512-1.3-1.249-1.648-1.249-1.648-1.021-.696.077-.681.077-.681 1.128.08 1.722 1.157 1.722 1.157 1.003 1.721 2.633 1.223 3.273.937.103-.729.396-1.223.715-1.505-2.498-.282-5.124-1.249-5.124-5.559 0-1.23.44-2.234 1.157-3.021-.113-.282-.501-1.428.11-2.977 0 0 .945-.3 3.095 1.153A10.77 10.77 0 0115 9.192a10.77 10.77 0 012.816.377c2.15-1.454 3.091-1.153 3.091-1.153.615 1.549.23 2.695.113 2.977.722.787 1.154 1.79 1.154 3.021 0 4.321-2.63 5.27-5.134 5.552.403.344.762 1.032.762 2.08 0 1.505-.011 2.717-.011 3.087 0 .3.2.652.772.542C23.031 24.185 26.25 19.97 26.25 15c0-6.215-5.035-11.25-11.25-11.25z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const InstagramIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.54395 0.46875C3.66028 0.46875 0.46875 3.65601 0.46875 7.54395V17.4561C0.46875 21.3397 3.65601 24.5312 7.54395 24.5312H17.4561C21.3397 24.5312 24.5312 21.344 24.5312 17.4561V7.54395C24.5312 3.66028 21.344 0.46875 17.4561 0.46875H7.54395ZM7.54395 2.65625H17.4561C20.1605 2.65625 22.3438 4.83948 22.3438 7.54395V17.4561C22.3438 20.1605 20.1605 22.3438 17.4561 22.3438H7.54395C4.83948 22.3438 2.65625 20.1605 2.65625 17.4561V7.54395C2.65625 4.83948 4.83948 2.65625 7.54395 2.65625ZM18.96 5.04883C18.4088 5.04883 17.9688 5.48889 17.9688 6.04004C17.9688 6.59119 18.4088 7.03125 18.96 7.03125C19.5111 7.03125 19.9512 6.59119 19.9512 6.04004C19.9512 5.48889 19.5111 5.04883 18.96 5.04883ZM12.5 5.9375C8.88977 5.9375 5.9375 8.88977 5.9375 12.5C5.9375 16.1102 8.88977 19.0625 12.5 19.0625C16.1102 19.0625 19.0625 16.1102 19.0625 12.5C19.0625 8.88977 16.1102 5.9375 12.5 5.9375ZM12.5 8.125C14.931 8.125 16.875 10.069 16.875 12.5C16.875 14.931 14.931 16.875 12.5 16.875C10.069 16.875 8.125 14.931 8.125 12.5C8.125 10.069 10.069 8.125 12.5 8.125Z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const TwitterIcon = () => {
  return (
    <svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.625 3.36133C25.6594 3.78857 24.6212 4.0791 23.5317 4.20727C24.6426 3.54077 25.4971 2.48547 25.8987 1.22937C24.8605 1.8446 23.7069 2.29321 22.4807 2.53674C21.498 1.48999 20.0967 0.832031 18.55 0.832031C15.5764 0.832031 13.1625 3.24597 13.1625 6.2196C13.1625 6.64258 13.2095 7.05273 13.3035 7.4458C8.82593 7.22363 4.85681 5.07886 2.20361 1.81897C1.73792 2.61365 1.47302 3.54077 1.47302 4.52771C1.47302 6.39477 2.42151 8.04395 3.86987 9.00952C2.98547 8.97961 2.15662 8.74036 1.4303 8.33447C1.4303 8.36011 1.4303 8.38147 1.4303 8.40283C1.4303 11.0133 3.28455 13.1923 5.74976 13.6836C5.29688 13.8075 4.82263 13.8759 4.3313 13.8759C3.98523 13.8759 3.64343 13.8417 3.31873 13.7776C4.00232 15.9181 5.99329 17.4733 8.34741 17.5203C6.50598 18.9644 4.18176 19.8231 1.66101 19.8231C1.22522 19.8231 0.797974 19.7975 0.375 19.7462C2.75903 21.2758 5.5874 22.1687 8.62939 22.1687C18.5372 22.1687 23.9547 13.9613 23.9547 6.84338C23.9547 6.61267 23.9462 6.37768 23.9376 6.14697C24.9886 5.38647 25.903 4.43799 26.625 3.36133Z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const DribbleIcon = () => {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 0.375C6.26245 0.375 0.375 6.26245 0.375 13.5C0.375 20.7375 6.26245 26.625 13.5 26.625C20.7375 26.625 26.625 20.7375 26.625 13.5C26.625 6.26245 20.7375 0.375 13.5 0.375ZM13.5 2.5625C16.2728 2.5625 18.785 3.60498 20.7119 5.29688C20.5068 5.58313 20.2291 5.9292 19.7891 6.35645C18.8534 7.26221 17.358 8.35168 15.0723 9.19336C13.5256 6.33508 12.0089 4.18604 11.0049 2.83594C11.8038 2.65222 12.6412 2.5625 13.5 2.5625ZM8.85156 3.58789C9.74878 4.76282 11.3467 6.94177 12.9531 9.84277C8.50549 11.022 4.42529 11.1715 2.80176 11.1758C3.52808 7.79626 5.80103 5.01489 8.85156 3.58789ZM22.2158 6.90332C23.5488 8.66785 24.3777 10.8511 24.4375 13.2266C23.4634 13.0087 22.0278 12.795 20.165 12.7822C19.1952 12.778 18.0972 12.8463 16.918 12.9873C16.6445 12.3635 16.3497 11.7611 16.0635 11.1758C18.5159 10.2358 20.1864 8.99683 21.293 7.92871C21.6689 7.56128 21.9637 7.22376 22.2158 6.90332ZM13.9443 11.8252C14.1964 12.3336 14.4528 12.8549 14.6963 13.3975C10.0222 14.692 6.66406 18.6569 5.22852 20.6436C3.57507 18.7295 2.5625 16.2344 2.5625 13.5C2.5625 13.453 2.5625 13.4103 2.5625 13.3633C4.04077 13.3804 8.74048 13.2778 13.9443 11.8252ZM20.165 14.9355C22.1176 14.9355 23.4677 15.209 24.2666 15.4141C23.7582 18.3279 22.1133 20.8273 19.7891 22.4551C19.3533 19.8403 18.6355 17.3538 17.7725 15.0723C18.6355 14.9868 19.4515 14.9355 20.165 14.9355ZM15.5508 15.4482C16.5334 17.9434 17.358 20.682 17.7725 23.583C16.4651 24.1342 15.0125 24.4375 13.5 24.4375C10.9921 24.4375 8.67639 23.5958 6.83496 22.1816C7.95862 20.6436 11.2612 16.5505 15.5508 15.4482Z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const MoonIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M16.576 6l-1.553.059C10.013 6.238 6 10.35 6 15.404c0 5.168 4.208 9.375 9.375 9.375 5.054 0 9.166-4.013 9.346-9.023l.058-1.524-1.377.645a5.57 5.57 0 01-2.402.527 5.612 5.612 0 01-5.625-5.625c0-.857.209-1.64.557-2.373L16.576 6zm-2.724 2.227c-.118.52-.352.996-.352 1.552 0 4.131 3.37 7.5 7.5 7.5.568 0 1.051-.23 1.582-.351-.714 3.398-3.589 5.976-7.207 5.976a7.486 7.486 0 01-7.5-7.5c0-3.61 2.585-6.456 5.977-7.177z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const SunIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M14.063 2.813V7.5h1.874V2.812h-1.874zm-7.032 2.9L5.713 7.03l3.31 3.34 1.348-1.348-3.34-3.31zm15.938 0l-3.34 3.31 1.348 1.348 3.31-3.34-1.318-1.318zM15 8.437c-3.614 0-6.563 2.949-6.563 6.563s2.949 6.563 6.563 6.563 6.563-2.948 6.563-6.563c0-3.614-2.948-6.563-6.563-6.563zm0 1.876c2.6 0 4.688 2.087 4.688 4.687S17.6 19.688 15 19.688A4.673 4.673 0 0110.312 15c0-2.6 2.088-4.688 4.688-4.688zm-12.188 3.75v1.874H7.5v-1.874H2.812zm19.688 0v1.874h4.688v-1.874H22.5zM9.023 19.628l-3.31 3.34 1.318 1.318 3.34-3.31-1.348-1.348zm11.954 0l-1.348 1.348 3.34 3.31 1.318-1.318-3.31-3.34zM14.062 22.5v4.688h1.876V22.5h-1.876z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const MenuIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M3.75 6.563v1.875h22.5V6.562H3.75zm0 7.5v1.874h22.5v-1.874H3.75zm0 7.5v1.875h22.5v-1.875H3.75z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const CloseIcon = () => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M8.174 6.826L6.826 8.174 13.652 15l-6.826 6.826 1.348 1.348L15 16.348l6.826 6.826 1.348-1.348L16.348 15l6.826-6.826-1.348-1.348L15 13.652 8.174 6.826z"
        fill="#7B88A8"
      />
    </svg>
  );
};
export const ArrowRightIcon = ({ color = '#7B88A8' }) => {
  return (
    <svg width={30} height={30} fill="none">
      <path
        d="M19.863 8.701l-1.318 1.348 4.014 4.014H3.75v1.874h18.809l-4.014 4.014 1.318 1.348 6.3-6.299-6.3-6.299z"
        fill={color}
      />
    </svg>
  );
};
